import { OrganizationAction } from './actions';

export interface OrganizationState {
  currentPanel: string | undefined;
  currentOrganizationId: string | undefined;
}

const initialState = {
  currentPanel: undefined,
  currentOrganizationId: undefined,
};

export function organizationReducer(
  state: OrganizationState = initialState,
  action: OrganizationAction,
) {
  switch (action.type) {
    case 'ORG.SET_CURRENT_PANEL':
      return {
        ...state,
        currentPanel: action.payload,
      };
    case 'ORG.SET_CURRENT_ORGANIZATION':
      return {
        ...state,
        currentOrganizationId: action.payload,
        currentPanel: undefined,
      };
    default:
      return state;
  }
}

export const ORGANIZATION_MODULE_KEY: 'organization' = 'organization';
export type OrganizationGlobalState = {
  [ORGANIZATION_MODULE_KEY]: OrganizationState;
};
